import PopupContainerComponent from '../components/PopupContainer/viewer/PopupContainer';
import PopupContainerController from '../components/PopupContainer/viewer/PopupContainer.controller';
import PopupPageComponent from '../components/PopupPage/viewer/PopupPage';
import ResponsivePopupContainerComponent from '../components/ResponsivePopupContainer/viewer/ResponsivePopupContainer';
import ResponsivePopupContainerController from '../components/ResponsivePopupContainer/viewer/ResponsivePopupContainer.controller';
import ResponsivePopupContainer_WithOverlayComponent from '../components/ResponsivePopupContainer/viewer/skinComps/WithOverlay/WithOverlay.skin';
import ResponsivePopupPageComponent from '../components/ResponsivePopupPage/viewer/ResponsivePopupPage';
import ResponsivePopupPage_WithoutOverlayComponent from '../components/ResponsivePopupPage/viewer/skinComps/WithoutOverlay/WithoutOverlay.skin';


const PopupContainer = {
  component: PopupContainerComponent,
  controller: PopupContainerController
};

const PopupPage = {
  component: PopupPageComponent
};

const ResponsivePopupContainer = {
  component: ResponsivePopupContainerComponent,
  controller: ResponsivePopupContainerController
};

const ResponsivePopupContainer_WithOverlay = {
  component: ResponsivePopupContainer_WithOverlayComponent,
  controller: ResponsivePopupContainerController
};

const ResponsivePopupPage = {
  component: ResponsivePopupPageComponent
};

const ResponsivePopupPage_WithoutOverlay = {
  component: ResponsivePopupPage_WithoutOverlayComponent
};


export const components = {
  ['PopupContainer']: PopupContainer,
  ['PopupPage']: PopupPage,
  ['ResponsivePopupContainer']: ResponsivePopupContainer,
  ['ResponsivePopupContainer_WithOverlay']: ResponsivePopupContainer_WithOverlay,
  ['ResponsivePopupPage']: ResponsivePopupPage,
  ['ResponsivePopupPage_WithoutOverlay']: ResponsivePopupPage_WithoutOverlay
};

